module.exports = __webpack_public_path__ + "static/media/bf15a156.jpg";